<template>
    <h5
        :class="
            twMerge(
                'whitespace-pre-line text-center text-[1rem] font-bold leading-[1.5] lg:text-[1.25rem] ',
                locale === 'ja' && '',
                locale === 'ko' && '',
                (locale === 'en' || lang === 'en') &&
                    'font-en text-[1.125rem] tracking-[-0.01em] lg:text-[1.25rem]',
                $attrs.class,
            )
        "
    >
        <slot />
    </h5>
</template>

<script setup>
import { twMerge } from "tailwind-merge";
const { lang = "tw" } = defineProps({ lang: { type: String, default: "tw" } });
const { locale } = useI18n();
</script>
